import UrlUtil from '@/util/UrlUtil';
import WxUtil from '@/util/WxUtil';
import { Toast } from 'vant';
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import QueryString from 'qs';

/**app静态方法*/
export default class AppUtil {
    static islogin = false;

    //判断是否为手机号的正则表达式
    public static check_phone(phones: string) {
        var myreg = /^[1][2-9][0-9]{9}$/;
        if (!myreg.test(phones)) {
            // console.log('手机号格式不正确')
            return false;
        } else {
            // console.log('手机号格式正确')
            return true;
        }
    }
    /**获取缩略图地址，默认宽高为200*/
    public static get_thumb(url: string, w = 200, h = 200): string {

        return url ? url + "?x-oss-process=image/resize,m_fill,h_" + h + ",w_" + w : "";
    }
    /**
     * config{
         * method post 或者get
         * url 接口地址
         * params 参数
     *} 
     * sucessFun 访问成功执行的方法
     * loading_tip 加载中的提示文本
     * endFunc 无论成功或者失败，都要执行的方法
     * Func401  当后台返回401时执行的方法， 可以阻止自动登陆
     */
    static request(config: AxiosRequestConfig, sucessFun: any, loading_tip = "", endFunc?: (value: boolean) => void, Func401?: () => void): void {
        if (AppUtil.islogin) {
            return;
        }
        if (loading_tip) {
            Toast.loading({
                message: loading_tip,
                forbidClick: true,
                duration: 0
            });
        }
        config.data = QueryString.stringify(config.data);
        axios(config).then((res: AxiosResponse) => {

            setTimeout(() => {//防止正常提示被$toast.clear()清除
                const data = res.data;
                let success = true;//成功或者失败
                if (data.code == 401) {
                    Func401?Func401():WxUtil.wxLogin();//如果存在401方法，执行401方法，反之自动登陆
                    
                } else if (data.code != 1) {
                    Toast(data.msg);
                    success = false;
                } else { //成功
                    sucessFun(data);
                }
                endFunc ? endFunc(success) : "";
            }, 100);

            // console.log('this.shop_info',this.shop_info);
        }).catch((error: any) => {

            // console.log(error);
            setTimeout(() => {//防止提示被$toast.clear()清除
                if (!error.response) {
                    return;
                }
                console.log('error.response.status',error.response.status);
                
                if (error.response.status == 401) {
                    console.log('Func401',Func401);
                    if(Func401){//如果存在401方法，执行401方法，反之自动登陆
                        Func401()
                    }else{
                        const code = UrlUtil.getUrlParam("code");
                        console.log('执行登陆',code);
                        code ? AppUtil.req_login(code) : WxUtil.wxLogin();
                    }

                } else {
                    if (error.response.data && error.response.data.errors) {
                        Toast(JSON.stringify(error.response.data.errors));
                    } else {
                        Toast(error.message);
                    }
                    endFunc ? endFunc(false) : "";
                }
            }, 100);
        }).finally(() => {
            Toast.clear();
        });
    }
    public static req_login(code: string) {
        console.log("执行登陆,code:", code);

        if (AppUtil.islogin) {
            return
        }

        let data: any = { code: code, domainUrl: document.domain };
        let pid = UrlUtil.getUrlParam("pid");
        console.log("pid", pid);

        if (pid) {
            data.pid = pid
        }

        if (localStorage.getItem("tenantId")) {
            data.tenantId = localStorage.getItem("tenantId");
        }
        AppUtil.request({
            url: "/zhMember/member/getOpenIdAndSessionKey",
            method: "post",
            data: data
        }, (res: any) => {
            //https://dymy888.cn/?appid=wx95ef041acc227602&code=0112c5ml2koYy94QLJll2BUvVs12c5mH&state=STATUS#/user

            // window.location.href="https://"+window.location.host+"/?appid="+UrlUtil.getUrlParam("appid");
            const href = window.location.href.replace('code=' + code + '&', '');
            window.history.replaceState({}, "", href);
            window.location.reload();

        });
        AppUtil.islogin = true;
    }
}
